import React from "react";
import { AllIconNames, Hint, Kebab as BaseKebab, PopupPositionsType } from "react-ui";

import { AbsoluteModelPath } from "../../../../../Common/ModelPath/ModelPath";
import { Icon } from "../../Icons/Icon";
import { useTestPageObject } from "../../Services/TestPageObjects/PageObjectExposure";
import { emptyRef } from "../../TypingUtils";

import { KebabTestPageObject } from "./KebabTestPageObject";

export interface KebabProps {
    bindingPath?: AbsoluteModelPath;
    children?: React.ReactNode;
    disabled?: boolean;
    onOpen?: () => void;
    onClose?: () => void;
    size?: "small" | "medium" | "large";
    positions?: PopupPositionsType[];
    menuMaxHeight?: number | string;
    icon?: AllIconNames;
    hint?: React.ReactNode;
    "data-tid"?: string;
    disableAnimations?: boolean;
}

export const Kebab = (props: KebabProps): JSX.Element => {
    const kebabRef = React.useRef<BaseKebab>(emptyRef);

    useTestPageObject(() => KebabTestPageObject(props.disabled, kebabRef), [props.disabled, kebabRef]);

    return (
        <Hint text={props.hint}>
            <span
                onClick={e => {
                    e.stopPropagation();
                }}>
                <BaseKebab
                    disableAnimations={props.disableAnimations ?? true}
                    data-tid={props["data-tid"]}
                    size={props.size}
                    disabled={props.disabled}
                    onOpen={props.onOpen}
                    onClose={props.onClose}
                    icon={props.icon ? <Icon name={props.icon} /> : undefined}
                    positions={props.positions}
                    menuMaxHeight={props.menuMaxHeight}
                    ref={kebabRef}>
                    {props.children}
                </BaseKebab>
            </span>
        </Hint>
    );
};
